import React from "react";
import Footer from "../Common/footer";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../Common/Navbar";
import MapwithList from "../UserDashboard/MapWithProperty/MapwithList";

import HomePageAdvetise from "../Home/Advertisement/HomePageAdvertise";
import HomePageAdvertiseMiddle from "../Home/Advertisement/HomePageAdvertiseMiddle";
import HomePageAdvertiseBottom from "../Home/Advertisement/HomePageAdvertiseBottom";

import TabComponent from "../Common/CalculatorTab";
import PropertyFilter from "./PropertyFilter";
import LatestProperties from "./LatestProperties";
import PopularProjects from "./PopularProjects";
import InsightTools from "./Insight&Tools";
import FeaturedProperty from "./FeaturedProperty";
import Vendors from "./Vendors";
import RealEstateGuide from "./RealEstateGuidance/RealEstateGuide";
import Testimoniol from "./Testimoniol";
import PremiumUsers from "./PremiumUsers";

function Home() {

  const token = localStorage.getItem("token");
  const UserRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate()
  console.log(token, "token")


  return (
    <section class="main ">
      <Navbar />
      <PropertyFilter />
      <section class=" mb-5 container-fluid">
        <div class="row">
          <MapwithList />
        </div>
      </section>
      <HomePageAdvetise />
      <LatestProperties />
      {/* <PopularProjects /> */}
      <InsightTools />
      <HomePageAdvertiseMiddle />
      <FeaturedProperty />
      <PremiumUsers/>
      <Vendors />
      <RealEstateGuide/>
      <TabComponent />
      <Testimoniol/>
      <HomePageAdvertiseBottom />

      <section class="download-app container">
        <div class="d-md-flex justify-content-between">
          <div class="left-download col-md-7">
            <h5>
              Download <span>Property Search</span> App For Android And Iphone
            </h5>
            <p>
              With our app, spend less time searching and more time at your
              dream Home. Download now!
            </p>
            <div class="scan-main d-lg-flex">
            <a
                href="https://play.google.com/store/apps/details?id=com.propertytech&pli=1"
                target="_blank"
                 rel="noopener noreferrer"
              >
                <img
                  className="google-play-img"
                  src="images/illustration/google-play.png"
                  alt="Google Play Store"
                />
              </a>
              {/* <img
                class="app-play-img"
                src="images/illustration/app-store.png"
                alt=""
              /> */}
              <span>Open Camera & Scan the QR code to Download the App</span>
              <img
                class="scan-img"
                src="images/illustration/code-scanner.png"
                alt=""
              />
            </div>
          </div>
          <div class="right-download">
            <img
              src="images/illustration/mob-img3-removebg-preview (1).png"
              alt=""
            />
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
}

export default Home;
